import React, { useState } from 'react';
import {
  Container,
  Stack,
  LinearProgress,
  Button,
} from '@mui/material';
import useCreateFormElements from './hooks/useCreateFormElements';
import ReactHookFormGenerator from 'Global/ReactHookFormGenerator/ReactHookFormGenerator';
import { useForm } from 'react-hook-form';
import SubmitButton from 'Global/Components/UnEditableComponents/SubmitButton/SubmitButton';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useGetParams from './hooks/useGetParams';
import { GetFish } from './adapters/GetFish';
import useGetDefaultSelect from './hooks/useGetDefaultSelect';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { Download, Visibility } from '@mui/icons-material';
import { ShowFish } from './adapters/ShowFish';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';

const InvoiceReceipt = () => {
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  const params = useGetParams();

  const showItem = useGetDefaultSelect(params);

  const get_check_msg = FindLangKey(
    'invoice-receipt-label-get-paycheck'
  );

 
  const elements = useCreateFormElements(params);

  const { control, formState, handleSubmit, getValues } =
    useForm({
      defaultValues: {
        Year: '',
        FromMonth: '',
        FishTypeID: '',
      },
    });

  const preview_msg = FindLangKey('general-public-preview');

  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop


 
  return (
    <React.Fragment>
      <Container>
        {!params || !showItem ? (
          <LinearProgress />
        ) : (
          <form
            onSubmit={handleSubmit((data) =>
              GetFish(data, setLoading)
            )}
          >
            <Stack marginTop="1em" gap=".5em">
              <ReactHookFormGenerator
                DataArray={elements}
                control={control}
                formState={formState}
              />
              <Stack direction="row-reverse" gap=".5em">
                <SubmitButton
                  label={get_check_msg}
                  startIcon={<Download />}
                />

                <Button
                  variant="contained"
                  sx={{
                    color: `${themeColors.ColorPrimary} !important`,
                    maxHeight: '40px !important',
                  }}
                  fullWidth
                  startIcon={<Visibility />}
                  onClick={() => {
                    if (preview) {
                      setPreview(null);
                    } else {
                      const data = getValues();
                      ShowFish(
                        data,
                        setLoading,
                        setPreview
                      );
                    }
                  }}
                >
                  {preview_msg}
                </Button>
              </Stack>
            </Stack>
          </form>
        )}
        <br />

        <>
          {loading ? (
            <LinearProgress />
          ) : preview ? (
            // <iframe
            //   src={preview}
            //   title={"report"}
            //   style={{
            //     border: "none",
            //     borderRadius: "5px",
            //     width: "100%",
            //   }}
            //   loading="در حال بارگیری"
            // />
            <></>
          ) : (
            <></>
          )}
        </>
      </Container>
    </React.Fragment>
  );
};

export default InvoiceReceipt;
